module.exports = __webpack_public_path__ + "static/media/jumbo-putt.1efbccb4.png";